import { render } from "./AdminButton.vue?vue&type=template&id=21efd12d&scoped=true"
import script from "./AdminButton.vue?vue&type=script&lang=js"
export * from "./AdminButton.vue?vue&type=script&lang=js"

import "./AdminButton.vue?vue&type=style&index=0&id=21efd12d&scoped=true&lang=css"

import exportComponent from "/Users/warths/refonte-manager-cli/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21efd12d"]])

export default __exports__